/** Admin Operations Center — business modules */
export const ADMIN_AI_FEATURES = [
  {
    id: "cms-lender-payouts",
    title: "Lender Payout Status",
    description: "Per deal — lenders paid or not paid (Interest, Principal, Principal+Interest)",
    icon: "fas fa-money-check-alt",
    color: "#059669",
    variant: "green",
    scope: "live",
    usesFy: false,
  },
  {
    id: "borrower-summary",
    title: "Borrower Summary",
    description: "Consolidated borrowers, amounts, fees, collateral in one view",
    icon: "fas fa-layer-group",
    color: "#2563eb",
    variant: "blue",
    scope: "live",
    usesFy: false,
  },
  {
    id: "borrower-fees",
    title: "Borrower Fees",
    description: "Processing, platform, and total fees by borrower",
    icon: "fas fa-file-invoice-dollar",
    color: "#d97706",
    variant: "amber",
    scope: "live",
    usesFy: false,
  },
  {
    id: "borrower-collateral",
    title: "Borrower Collateral",
    description: "FD collateral value, verified, pending, and released",
    icon: "fas fa-shield-alt",
    color: "#059669",
    variant: "green",
    scope: "live",
    usesFy: false,
  },
  {
    id: "portfolio-overview",
    title: "Portfolio Overview",
    description: "Running, closed, and overall deal & investment portfolio",
    icon: "fas fa-chart-pie",
    color: "#6366f1",
    variant: "indigo",
    scope: "live",
    usesFy: false,
  },
  {
    id: "operations-alerts",
    title: "Priority Alerts",
    description: "CMS pending, open deals, and wallet items needing action today",
    icon: "fas fa-bell",
    color: "#d97706",
    variant: "amber",
    scope: "live",
    usesFy: false,
  },
  {
    id: "borrower-accounts",
    title: "Borrower Portfolio",
    description: "FD collateral, fees, ROI, and repayment status per borrower",
    icon: "fas fa-user-graduate",
    color: "#2563eb",
    variant: "blue",
    scope: "live",
    usesFy: false,
  },
  {
    id: "fees-revenue",
    title: "Revenue & Fees",
    description: "Borrower fees, lender interest, principal, and spread margin",
    icon: "fas fa-receipt",
    color: "#2563eb",
    variant: "blue",
    scope: "live",
    usesFy: false,
  },
  {
    id: "deal-roi-board",
    title: "Deal Performance",
    description: "Fill rate, lender & borrower ROI, spread, and risk per deal",
    icon: "fas fa-table-list",
    color: "#6366f1",
    variant: "indigo",
    scope: "live",
    usesFy: false,
  },
  {
    id: "deals-directory",
    title: "Deal Directory",
    description: "Open, active, and closed deals — searchable list",
    icon: "fas fa-briefcase",
    color: "#6366f1",
    variant: "indigo",
    scope: "live",
    usesFy: false,
  },
  {
    id: "view-payments",
    title: "Payout Schedule",
    description: "Upcoming lender interest payments by deal",
    icon: "fas fa-calendar-check",
    color: "#0d9488",
    variant: "teal",
    scope: "live",
    usesFy: false,
  },
  {
    id: "deal-intelligence",
    title: "Deal Recommendations",
    description: "Close, relaunch, or launch — AI-assisted deal actions",
    icon: "fas fa-lightbulb",
    color: "#7c3aed",
    variant: "violet",
    scope: "live",
    usesFy: false,
  },
  {
    id: "cms-reconciliation",
    title: "CMS Reconciliation",
    description: "Bank payout initiated vs confirmed — daily status",
    icon: "fas fa-scale-balanced",
    color: "#d97706",
    variant: "amber",
    scope: "live",
    usesFy: false,
  },
  {
    id: "capital-liquidity",
    title: "Wallet & Liquidity",
    description: "Escrow balance, deployment, withdrawals, and returns",
    icon: "fas fa-wallet",
    color: "#0891b2",
    variant: "teal",
    scope: "live",
    usesFy: false,
  },
  {
    id: "top-lenders",
    title: "Top Lenders",
    description: "Highest participation by investment amount",
    icon: "fas fa-trophy",
    color: "#eab308",
    variant: "amber",
    scope: "live",
    usesFy: false,
  },
  {
    id: "lender-directory",
    title: "Lender Directory",
    description: "Contact details and participation by lender",
    icon: "fas fa-address-book",
    color: "#5c9b45",
    variant: "green",
    scope: "live",
    usesFy: false,
  },
  {
    id: "platform-users",
    title: "User Analytics",
    description: "Lender and borrower counts, registrations, and growth",
    icon: "fas fa-users",
    color: "#0891b2",
    variant: "teal",
    scope: "live",
    usesFy: false,
  },
  {
    id: "participation-insights",
    title: "Participation Mix",
    description: "Monthly, quarterly, and annual return preferences",
    icon: "fas fa-chart-pie",
    color: "#0891b2",
    variant: "teal",
    scope: "live",
    usesFy: false,
  },
  {
    id: "risk-summary",
    title: "Risk Overview",
    description: "Portfolio concentration and lender risk scores",
    icon: "fas fa-shield-halved",
    color: "#dc2626",
    variant: "rose",
    scope: "live",
    usesFy: false,
  },
  {
    id: "financial-kpis",
    title: "FY Financial KPIs",
    description: "Interest, principal, and deal counts for selected FY",
    icon: "fas fa-gauge-high",
    color: "#2563eb",
    variant: "blue",
    scope: "fy",
    usesFy: true,
  },
  {
    id: "fy-earners",
    title: "FY Top Earners",
    description: "Lenders with highest interest earned this FY",
    icon: "fas fa-medal",
    color: "#eab308",
    variant: "amber",
    scope: "fy",
    usesFy: true,
  },
  {
    id: "monthly-payout",
    title: "FY Payout Trend",
    description: "Month-wise payout volume for selected FY",
    icon: "fas fa-chart-line",
    color: "#3b82f6",
    variant: "blue",
    scope: "fy",
    usesFy: true,
  },
  {
    id: "top-deals",
    title: "FY Top Deals",
    description: "Highest volume deals in selected financial year",
    icon: "fas fa-handshake",
    color: "#6366f1",
    variant: "indigo",
    scope: "fy",
    usesFy: true,
  },
];

export const LIVE_FEATURES = ADMIN_AI_FEATURES.filter((f) => f.scope === "live");
export const FY_FEATURES = ADMIN_AI_FEATURES.filter((f) => f.scope === "fy");
export const getFeatureById = (id) => ADMIN_AI_FEATURES.find((f) => f.id === id) || null;
